var _path, _path2, _g, _path3, _g2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 258,
    viewBox: "0 0 220 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.52 28.5551H93.3749V66.3163H126.52V28.5551Z",
    fill: "#B3A1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_139_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 0,
    width: 43,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2515 0H130.817V28.8876H88.2515V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_139_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.655 28.5552H89.2317V0.0263672H130.655V28.5552Z",
    fill: "#C3B6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_139_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 37,
    width: 220,
    height: 221
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.8489H220V257.788H0V37.8489Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_139_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.945 237.061C60.812 237.061 20.9767 197.23 20.9767 148.092C20.9767 98.954 60.812 59.1143 109.945 59.1143C159.088 59.1143 198.914 98.954 198.914 148.092C198.914 197.23 159.088 237.061 109.945 237.061ZM109.945 38.1815C49.2474 38.1815 0.0395508 87.3893 0.0395508 148.092C0.0395508 208.786 49.2474 257.993 109.945 257.993C170.648 257.993 219.856 208.786 219.856 148.092C219.856 87.3893 170.648 38.1815 109.945 38.1815Z",
    fill: "#C3B6F8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.652 144.381C113.652 146.429 111.998 148.092 109.945 148.092C107.898 148.092 106.244 146.429 106.244 144.381V81.5783C106.244 79.5305 107.898 77.8678 109.945 77.8678C111.998 77.8678 113.652 79.5305 113.652 81.5783V144.381Z",
    fill: "#E69800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.608 150.564C112.387 151.085 110.746 149.973 109.945 148.092C109.149 146.206 109.495 144.254 110.72 143.742L148.21 127.863C149.435 127.343 151.076 128.454 151.868 130.344C152.673 132.226 152.323 134.177 151.106 134.689L113.608 150.564Z",
    fill: "#E69800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f972025e97af17e7440ac6e404a899bb.svg";
export { ForwardRef as ReactComponent };